<template>
  <el-dialog :close-on-click-modal="false" v-dialogDrag :title="title" :visible.sync="detailDialog" width="80%" append-to-body :before-close="handleClose">
    <div class="max-height-60 ">
      <el-form :model="form" inline label-width="100px" ref="form">
        <el-form-item label="手机号码:">
          <div class="raisediv">
            {{ form.mobilePhone }}
          </div>
        </el-form-item>
        <el-form-item label="会员名字:">
          <div class="raisediv">
            {{ form.memberName }}
          </div>
        </el-form-item>
        <div class="flex justify-center align-start flex-wrap padding-top">
          <div class="into-table-width margin-right-xs">
            <div class="raisetable margin-bottom-xs">
              <div class="raisetable margin-bottom-xs">
                <div class="raisetable-sum">
                  <span>转出疗程 </span>
                </div>
                <el-table :data="outList" max-height="200" :header-cell-style="{ background: 'linear-gradient(#6cb3ff, #1873d4)', color: '#eeeeee' }" style="margin-top: 5px">
                  <el-table-column type="expand">
                    <template slot-scope="scope">
                      <span class="padding-left-sm ">员工</span>
                      <div class=" flex  align-start flex-wrap padding-top">
                        <staffslesout ref="staffslesout" :entities="scope.row.entities"></staffslesout>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="项目编码" align="center" prop="projectNum" min-width="80"></el-table-column>
                  <el-table-column label="项目编码" align="center" prop="projectNum" min-width="80"></el-table-column>
                  <el-table-column label="账户名称" align="center" prop="courseProjectName" min-width="140"></el-table-column>
                  <el-table-column label="可用次数" align="center" prop="courseConsumeCount" min-width="100"></el-table-column>
                  <el-table-column label="疗程单价" align="center" prop="unitMoney" min-width="100"></el-table-column>
                  <el-table-column label="转出次数" align="center" prop="changeOutTime" min-width="100"></el-table-column>
                  <el-table-column label="转出金额" align="center" prop="changeOutMoney" min-width="100"></el-table-column>
                </el-table>
              </div>
              <div class="raisetable-sum">
                <span>转入疗程</span>
              </div>
              <el-table :data="inList" max-height="150" :header-cell-style="{ background: 'linear-gradient(#6cb3ff, #1873d4)', color: '#eeeeee' }" style="margin-top: 5px">
                <el-table-column show-overflow-tooltip label="项目编码" align="center" prop="projectNum" min-width="80"></el-table-column>
                <el-table-column show-overflow-tooltip label="账户名称" align="center" prop="projectName" min-width="110"></el-table-column>
                <el-table-column label="标准单价" align="center" prop="priceMember" min-width="75">
                </el-table-column>
                <el-table-column label="最低单价" align="center" prop="minumumPriceMember" min-width="75"></el-table-column>
                <el-table-column label="转入次数" align="center" prop="changeInTime" min-width="75"> </el-table-column>
                <el-table-column label="转入金额" align="center" prop="changeInMoney" min-width="75"> </el-table-column>
                <el-table-column label="欠款金额" v-if="sessionStorageData.allowdebt" align="center" prop="debtMoney" min-width="75"></el-table-column>
                <el-table-column label="成交金额" align="center" prop="transactionMoney" min-width="75"></el-table-column>
              </el-table>
            </div>

          </div>
          <div style="width:280px;" class="border-radius-10 border bg-white padding-xs">
            <el-table :data="payLists" show-summary >
              <el-table-column align="center" prop="payId" label="支付方式" min-width="100">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.payId" placeholder="请选择">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="payMoney" label="本次支付" min-width="80"></el-table-column>
            </el-table>
          </div>
        </div>
        <span class="padding-left-sm ">员工/门店管理层/高管业绩</span>
        <div class=" flex  align-start flex-wrap padding-top">
          <staffsles ref="staffsles" @staffslesData="staffslesData" ></staffsles>
          <admin ref="admin" @adminData="adminData"></admin>
          <manager ref="manager" @managerData="managerData" ></manager>
        </div>
      </el-form>
    </div>
    <!-- <span slot="footer" class="dialog-footer" v-if="title=='明细'">
      <el-button size="mini" type="primary" @click="detailDialog=false">关闭</el-button>
    </span> -->
    <span  slot="footer" class="dialog-footer">
      <el-button size="mini" type="primary" plain @click="cancel()">取 消</el-button>
      <el-button size="mini" type="primary" @click="subStaffRatio()" v-if="isTrue">修 改</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  cardChangeEditStaff,
  cardChangeinPro,
  selectOne,
  cardChangeOutPro,
  ctlist
} from "@/api/eashier.js";
import admin from "@/components/staffList/admin/index";
import manager from "@/components/staffList/manager/index";
import staffsles from "@/components/staffList/staff/index";
import staffslesout from "./staff.vue";
export default {
  props:{ //其他地方用到，勿删
    isTrue:{
      type:Boolean,
      default:true
    }
  },
  components: {
    staffsles,
    staffslesout,
    manager,
    admin,
  },
  data() {
    return {
      detailDialog: false,
      sessionStorageData: {
        allowdebt: false,
      },
      payLists: [], //现付列表
      inList: [],
      outList: [],
      activeNames: "员工",
      title: "", //弹窗标题
      form: {}, //主对象
      options:[]
    };
  },
  created(){
    this.init()
  },
  methods: {
    init(){
      ctlist({
        state: 1
      }).then(res=>{
        this.options = res.rows.map(item=>{
          return {
            value:item.id,
            label:item.collectionTypeName
          }
        })
      })
    },
    //关闭弹窗前的回调方法
    handleClose() {
      this.form = Object.assign({});
      this.inList = [];
      this.outList = [];
      this.payLists = [];
      this.detailDialog = false;
      this.$refs.form.clearValidate();
    },
    setStaff() {
      var that = this;
      this.$nextTick(() => {
        that.$refs.staffsles.show(that.form.staffLists);
        that.$refs.admin.show(that.form.adminList);
        that.$refs.manager.show(that.form.managerList);
      });
    },
    //员工占比返回方法
    staffslesData(v) {
      this.form.staffLists = [...v];
    },
    staffslesDataout(v) {
      this.form.staffListsout = [...v];
    },
    //高管占比返回方法
    managerData(v) {
      this.form.managerList = [...v];
    },
    //管理员占比返回方法
    adminData(v) {
      this.form.adminList = [...v];
    },
    cancel() {
      this.$emit("detailData");
      this.inList = [];
      this.outList = [];
      this.payLists = [];
      this.detailDialog = false;
      this.$refs.form.clearValidate();
      this.form = Object.assign({});
    },
    //组件传值
    show(form, text) {
      if (text == "修改") {
        this.title = text;
      } else {
        this.title = "明细";
      }
      this.detailDialog = true;
      this.getData(form);
    },
    getData(form) {
      this.sessionStorageData = JSON.parse(
        sessionStorage.getItem("sessionStorageData")
      );
      this.form = { ...form };
      cardChangeinPro({
        docNum: form.docNum,
        id: form.id,
      }).then((res) => {
        if (res.code == "000000") {
          this.payLists = res.rows[0].payLists;
          res.rows[0].entities.forEach((item) => {
            item.id = item.saleStaffId;
            item.staffName = item.saleStaffName;
            item.ratio = item.saleRatio;
            item.identityCard = item.saleIdentityCard;
          });
          this.form.staffLists = res.rows[0].entities;
          this.form.staffLists.forEach((items) => {
            items.staffNames = items.brandNumber + "--" + items.staffName;
          });
          selectOne({ type: 3, orderId: res.rows[0].id }).then((res) => {
            if (res.code == "000000") {
              let managerList = [];
              let adminList = [];
              res.rows.forEach((item) => {
                if (item.staffType == 0) {
                  item.staffNames = item.brandNumber + "--" + item.staffName;
                  managerList.push(item);
                }
                if (item.staffType == 1) {
                  item.staffNames = item.brandNumber + "--" + item.staffName;
                  adminList.push(item);
                }
              });
              if (managerList.length == 0) {
                managerList.push({ ratio: 100 });
              }
              if (adminList.length == 0) {
                adminList.push({ ratio: 100 });
              }
              if (this.form.staffLists.length == 0) {
                this.form.staffLists.push({ ratio: 100 });
              }
              this.form.managerList = managerList;
              this.form.adminList = adminList;
              this.setStaff();
            
            } else {
              this.$alert(res.message, "加载门店高管", {
                confirmButtonText: "确定",
                confirmButtonClass: "confirmbtnFalses",
                type: "warning",
                center: true,
                callback: (action) => {},
              });
            }
          });
          this.inList = res.rows;
        } else {
          this.$alert("加载转入列表 : " + res.message, "提示", {
            confirmButtonText: "确定",
            confirmButtonClass: "confirmbtnFalses",
            type: "warning",
            center: true,
            callback: (action) => {},
          });
        }
      });
      cardChangeOutPro({
        docNum: form.docNum,
      }).then((res) => {
        if (res.code == "000000") {
          this.outList = res.rows;
          this.outList.forEach(item=>{
            item.entities.forEach(items=>{
              items.staffNames = items.brandNumber + "--" + items.saleStaffName;
            })
          })
          this.form.staffListsout = res.rows[0].entities;
          this.form.staffListsout.forEach((items) => {
            items.staffNames = items.brandNumber + "--" + items.saleStaffName;
          });
        } else {
          this.$alert("加载转出列表 : " + res.message, "提示", {
            confirmButtonText: "确定",
            confirmButtonClass: "confirmbtnFalses",
            type: "warning",
            center: true,
            callback: (action) => {},
          });
        }
      });
    },
    //指定列求和
    //数组按对应字段合计返回方法
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (column.property == "payMoney") {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              sums[index] = "--";
            }
          }, 0);
          sums[index] += " ";
        } else {
          sums[index] = "--";
        }
      });
      return sums;
    },
    subStaffRatio() {
      let form = {
        docNum: this.form.docNum,
        docDate: this.form.docDate,
        storeId: this.form.storeId,
        cardChangeInProjectRequest: {},
        payLists:this.payLists,
        cardChangeOutProjectRequests:this.outList
      };
      let salesmens = [];
      this.form.managerList.forEach((item) => {
        if (item.id) {
          item.staffType = 0;
          salesmens.push(item);
        }
      });
      this.form.adminList.forEach((item) => {
        if (item.id) {
          item.staffType = 1;
          salesmens.push(item);
        }
      });
      form.cardChangeInProjectRequest = {
        staffLists: this.form.staffLists,
        id: this.inList[0].id,
        salesmens: salesmens,
      };
      cardChangeEditStaff(form).then((res) => {
        if (res.code == "000000") {
          this.$message.success({
            message: res.message,
          });
          this.detailDialog = false;
          this.$emit("detailData");
        } else {
          this.$alert("修改员工 : " + res.message, "提示", {
            confirmButtonText: "确定",
            confirmButtonClass: "confirmbtnFalses",
            type: "warning",
            center: true,
            callback: (action) => {},
          });
        }
      });
    },
  },
};
</script>

<style scoped>
/deep/ .el-dialog .el-form .el-select, .el-dialog .el-form .el-date-editor{
  width: 0.6rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/eashier/raiseReatment/components/detail.vue